import { isDownloadBlocked } from '#shared/utils/download-access'

export function useDownloadAccess() {
  const { user } = useUserSession()
  const { eanNotDownloadable, restrictedNsLaw } = useRuntimeConfig().public.licenses

  const canDownload = computed(() => {
    const current = user.value
    if (!current?.licenses?.length) {
      return false
    }
    return !isDownloadBlocked(current, eanNotDownloadable)
  })

  function canDownloadLawText(lawId: string | undefined) {
    if (!lawId) {
      return false
    }

    const isNsLaw = lawId.toLowerCase().includes(restrictedNsLaw)

    // Disable download law text if it's NS law
    return !isNsLaw
  }

  return {
    canDownload,
    canDownloadLawText,
  }
}
